import { Button, InputLabel, MenuItem, Select, Switch, TextField } from '@mui/material'
import React, { useEffect } from 'react'
import { useRecipesHook } from '../../../Hooks/communicators/useRecipesHook'
import { useSelector } from 'react-redux';
import { useTagsHook } from '../../../Hooks/communicators/useTagsHook';
import NumberInput from '../../../Components/NumberInput';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function AddNewRecipe() {
    const {
        recipeTypes,
        recipeTrimesters,
        recipeName,
        setRecipeName,
        recipeType,
        setRecipeType,
        recipeTrimester,
        setRecipeTrimester,
        recipePreparationTime,
        setRecipePreparationTime,
        recipeCookTime,
        setRecipeCookTime,
        recipeServes,
        setRecipeServes,
        recipeTags,
        setRecipeTags,
        recipeMethod,
        setRecipeMethod,
        recipeIngredients,
        setRecipeIngredients,
        recipeImage,
        setRecipeImage,
        recipeCarbs,
        setRecipeCarbs,
        recipeProtein,
        setRecipeProtein,
        recipeFats,
        setRecipeFats,
        recipeCalories,
        setRecipeCalories,
        recipeCalcium,
        setRecipeCalcium,
        recipeVitaminA,
        recipeVitaminAUnit,
        recipeVitaminB6,
        recipeVitaminB6Unit,
        recipeVitaminB12,
        recipeVitaminB12Unit,
        recipeVitaminC,
        recipeVitaminCUnit,
        recipeVitaminD,
        recipeVitaminDUnit,
        recipeVitaminE,
        recipeVitaminEUnit,
        recipeVitaminK,
        recipeVitaminKUnit,
        setRecipeVitaminA,
        setRecipeVitaminAUnit,
        setRecipeVitaminB6,
        setRecipeVitaminB6Unit,
        setRecipeVitaminB12,
        setRecipeVitaminB12Unit,
        setRecipeVitaminC,
        setRecipeVitaminCUnit,
        setRecipeVitaminD,
        setRecipeVitaminDUnit,
        setRecipeVitaminE,
        setRecipeVitaminEUnit,
        setRecipeVitaminK,
        setRecipeVitaminKUnit,
        blogReferences,
        setBlogReferences,
        isPremium,
        setIsPremium,
        addNewRecipe,
        selectableRecipeTags,
        handleFileChange,
        uploading,
        progress,
        vitaminUnits,
        recipeCholesterol,
        recipeCholesterolUnit,
        recipeCholine,
        recipeCholineUnit,
        recipeFiber,
        recipeFiberUnit,
        recipeFolicAcid,
        recipeFolicAcidUnit,
        recipeIodine,
        recipeIodineUnit,
        recipeIron,
        recipeIronUnit,
        recipeMagnesium,
        recipeMagnesiumUnit,
        recipePotassium,
        recipePotassiumUnit,
        recipeSaturatedFat,
        recipeSaturatedFatUnit,
        setRecipeCholesterol,
        setRecipeCholesterolUnit,
        setRecipeCholine,
        setRecipeCholineUnit,
        setRecipeFiber,
        setRecipeFiberUnit,
        setRecipeFolicAcid,
        setRecipeFolicAcidUnit,
        setRecipeIodine,
        setRecipeIodineUnit,
        setRecipeIron,
        setRecipeIronUnit,
        setRecipeMagnesium,
        setRecipeMagnesiumUnit,
        setRecipePotassium,
        setRecipePotassiumUnit,
        setRecipeSaturatedFat,
        setRecipeSaturatedFatUnit,
    } = useRecipesHook();
    const {
        recipesLoading,
    } = useSelector((state: any) => state.recipe.value);
    const {
        fetchTags,
    } = useTagsHook();
    const { globalTags } = useSelector((state: any) => state.tags.value);
    
    // Quill editor configuration
    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'align': [] }],
            ['link', 'image'],
            ['clean']
        ],
    };

    const formats = [
        'header', 'bold', 'italic', 'underline', 'strike',
        'color', 'background', 'list', 'bullet', 'indent',
        'align', 'link', 'image'
    ];
    
    useEffect(() => {
        fetchTags();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [recipeIngredientsForRender, setRecipeIngredientsForRender] = React.useState<any>("");
    return (
        <div className='flex justify-start items-center flex-col'>
            <h1 className='text-2xl font-bold my-8'>
                Create New Recipe
            </h1>
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Recipe Name
            </InputLabel>
            <TextField
                label='Recipe Name'
                variant='filled'
                style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                type="text"
                placeholder='Recipe Name'
                value={recipeName}
                onChange={(e) => setRecipeName(e.target.value)}
            />
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Recipe Type
            </InputLabel>
            <Select
                style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                value={recipeType}
                label="Type"
                onChange={(e: any) => setRecipeType(e.target.value)}>
                {
                    recipeTypes.map((option: any) => {
                        return (
                            <MenuItem value={option.value}>{option.title}</MenuItem>
                        )
                    })
                }
            </Select>
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Recipe Image
            </InputLabel>
            <TextField
                variant='filled'
                style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                type="file"
                // value={blogImage}
                onChange={handleFileChange}
            />
            {
                <div>
                    {
                        uploading === true
                            ? <p>Uploading...</p>
                            : null
                    }
                    {
                        uploading === true && progress !== 0
                            ? <p>{progress}%</p>
                            : null
                    }
                </div>
            }
            {
                recipeImage !== ''
                    ?
                    <div>
                        <img
                            src={recipeImage}
                            alt="Uploaded"
                            style={{ width: '450px', height: 'auto' }}
                        />
                    </div>
                    : null
            }
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Recipe Trimester
            </InputLabel>
            <Select
                style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                value={recipeTrimester}
                label="Trimester"
                onChange={(e: any) => setRecipeTrimester(e.target.value)}>
                {
                    recipeTrimesters.map((option: any) => {
                        return (
                            <MenuItem value={option.value}>{option.title}</MenuItem>
                        )
                    })
                }
            </Select>
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Recipe Preparation Time
            </InputLabel>
            <NumberInput
                width='450px'
                value={recipePreparationTime}
                onChange={(value) => setRecipePreparationTime(value)}
            />
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Recipe Cook Time
            </InputLabel>
            <NumberInput
                width='450px'
                value={recipeCookTime}
                onChange={(value) => setRecipeCookTime(value)}
            />
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Recipe Serves
            </InputLabel>
            <NumberInput
                value={recipeServes}
                onChange={(value) => setRecipeServes(value)}
            />
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Recipe Tag
            </InputLabel>
            <Select
                multiple
                style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                value={recipeTags}
                label="Recipe Tag"
                onChange={(e: any) => setRecipeTags(e.target.value)}>
                {
                    globalTags.map((option: any) => {
                        return (
                            <MenuItem value={option}>{option}</MenuItem>
                        )
                    })
                }
            </Select>
            <Button
                onClick={() => fetchTags()}
                style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                variant='contained'
                color='primary'>
                Fetch Tags Manually (If not updated)
            </Button>
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Recipe Ingredients
            </InputLabel>
            <div style={{ width: '450px', marginTop: '16px', marginBottom: '70px' }}>
                <ReactQuill
                    theme="snow"
                    value={recipeIngredientsForRender}
                    onChange={(content) => {
                        setRecipeIngredientsForRender(content)
                        setRecipeIngredients(content.split('\n'));
                    }}
                    modules={modules}
                    formats={formats}
                    style={{
                        height: '250px',
                    }}
                    placeholder="Write recipe ingredients here..."
                />
            </div>
            {/* <TextField
                label='Recipe Ingredients'
                variant='filled'
                style={{
                    width: '450px',
                    marginBottom: '16px',
                    marginTop: '16px'
                }}
                type="text"
                placeholder='Recipe Ingredients'
                value={recipeIngredientsForRender}
                onChange={(e) => setRecipeIngredientsForRender(e.target.value)}
            />
            <Button
                disabled={recipeIngredientsForRender === ''}
                onClick={() => {
                    setRecipeIngredients([...recipeIngredients, recipeIngredientsForRender]);
                    setRecipeIngredientsForRender("");
                }}
                style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                variant='contained'
                color='primary'>
                Add Ingredient
            </Button>
            {
                recipeIngredients.length > 0
                    ?
                    <div>
                        {
                            recipeIngredients.map((ingredient: any) => {
                                return (
                                    <div
                                        key={ingredient}
                                        className='flex flex-row justify-start items-start'
                                    >
                                        <p className='text-lg font-semibold'>* {ingredient}</p>
                                        <DeleteOutlineIcon
                                            onClick={() => {
                                                setRecipeIngredients(recipeIngredients.filter((item: any) => item !== ingredient))
                                            }}
                                            style={{
                                                position: 'relative',
                                                cursor: 'pointer',
                                                top: '2.5px',
                                                left: '8px',
                                            }}
                                            color='primary'
                                        >
                                            Remove Ingredient
                                        </DeleteOutlineIcon>
                                    </div>
                                )
                            })
                        }
                    </div>
                    : null
            } */}
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Recipe Method
            </InputLabel>
            <div style={{ width: '450px', marginTop: '16px', marginBottom: '70px' }}>
                <ReactQuill
                    theme="snow"
                    value={recipeMethod}
                    onChange={setRecipeMethod}
                    modules={modules}
                    formats={formats}
                    style={{
                        height: '250px',
                    }}
                    placeholder="Write recipe method here..."
                />
            </div>
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Recipe Calories
            </InputLabel>
            <NumberInput
                value={recipeCalories}
                onChange={(value) => setRecipeCalories(value)}
            />
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Recipe Carbs
            </InputLabel>
            <NumberInput
                value={recipeCarbs}
                onChange={(value) => setRecipeCarbs(value)}
            />
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Recipe Proteins
            </InputLabel>
            <NumberInput
                value={recipeProtein}
                onChange={(value) => setRecipeProtein(value)}
            />
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Recipe Total Fats
            </InputLabel>
            <NumberInput
                value={recipeFats}
                onChange={(value) => setRecipeFats(value)}
            />
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Recipe Calcium
            </InputLabel>
            <NumberInput
                value={recipeCalcium}
                onChange={(value) => setRecipeCalcium(value)}
            />
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '32px'
                }}>
                Vitamin A
            </InputLabel>
            <div className='flex flex-row justify-start items-start my-4 w-full'>
                <div>
                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Amount
                    </InputLabel>
                    <NumberInput
                        marginTop={'8px'}
                        value={recipeVitaminA}
                        onChange={(value) => setRecipeVitaminA(value)}
                    />
                </div>
                <div className='ml-4'>
                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Unit
                    </InputLabel>
                    <Select
                        sx={{ width: '100px', marginTop: '8px' }}
                        value={recipeVitaminAUnit}
                        label="Vitamin B Unit"
                        onChange={(e: any) => setRecipeVitaminAUnit(e.target.value)}>
                        {
                            vitaminUnits.map((unit: any) => {
                                return (
                                    <MenuItem value={unit.title}>{unit.value}</MenuItem>
                                )
                            })
                        }
                    </Select>
                </div>
            </div>
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Vitamin B6
            </InputLabel>
            <div className='flex flex-row justify-start items-start my-4 w-full'>
                <div>

                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Amount
                    </InputLabel>
                    <NumberInput
                        marginTop={'8px'}
                        value={recipeVitaminB6}
                        onChange={(value) => setRecipeVitaminB6(value)}
                    />
                </div>
                <div className='ml-4'>
                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Unit
                    </InputLabel>
                    <Select
                        sx={{ width: '100px', marginTop: '8px' }}
                        value={recipeVitaminB6Unit}
                        label="Vitamin B6 Unit"
                        onChange={(e: any) => setRecipeVitaminB6Unit(e.target.value)}>
                        {
                            vitaminUnits.map((unit: any) => {
                                return (
                                    <MenuItem value={unit.title}>{unit.value}</MenuItem>
                                )
                            })
                        }
                    </Select>
                </div>
            </div>
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Vitamin B12
            </InputLabel>
            <div className='flex flex-row justify-start items-start my-4 w-full'>
                <div>

                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Amount
                    </InputLabel>
                    <NumberInput
                        marginTop={'8px'}
                        value={recipeVitaminB12}
                        onChange={(value) => setRecipeVitaminB12(value)}
                    />
                </div>
                <div className='ml-4'>
                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Unit
                    </InputLabel>
                    <Select
                        sx={{ width: '100px', marginTop: '8px' }}
                        value={recipeVitaminB12Unit}
                        label="Vitamin B12 Unit"
                        onChange={(e: any) => setRecipeVitaminB12Unit(e.target.value)}>
                        {
                            vitaminUnits.map((unit: any) => {
                                return (
                                    <MenuItem value={unit.title}>{unit.value}</MenuItem>
                                )
                            })
                        }
                    </Select>
                </div>
            </div>
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Vitamin C
            </InputLabel>
            <div className='flex flex-row justify-start items-start my-4 w-full'>
                <div>

                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Amount
                    </InputLabel>
                    <NumberInput
                        marginTop={'8px'}
                        value={recipeVitaminC}
                        onChange={(value) => setRecipeVitaminC(value)}
                    />
                </div>
                <div className='ml-4'>
                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Unit
                    </InputLabel>
                    <Select
                        sx={{ width: '100px', marginTop: '8px' }}
                        value={recipeVitaminCUnit}
                        label="Vitamin C Unit"
                        onChange={(e: any) => setRecipeVitaminCUnit(e.target.value)}>
                        {
                            vitaminUnits.map((unit: any) => {
                                return (
                                    <MenuItem value={unit.title}>{unit.value}</MenuItem>
                                )
                            })
                        }
                    </Select>
                </div>
            </div>
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Vitamin D
            </InputLabel>
            <div className='flex flex-row justify-start items-start my-4 w-full'>
                <div>

                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Amount
                    </InputLabel>
                    <NumberInput
                        marginTop={'8px'}
                        value={recipeVitaminD}
                        onChange={(value) => setRecipeVitaminD(value)}
                    />
                </div>
                <div className='ml-4'>
                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Unit
                    </InputLabel>
                    <Select
                        sx={{ width: '100px', marginTop: '8px' }}
                        value={recipeVitaminDUnit}
                        label="Vitamin D Unit"
                        onChange={(e: any) => setRecipeVitaminDUnit(e.target.value)}>
                        {
                            vitaminUnits.map((unit: any) => {
                                return (
                                    <MenuItem value={unit.title}>{unit.value}</MenuItem>
                                )
                            })
                        }
                    </Select>
                </div>
            </div>
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Vitamin E
            </InputLabel>
            <div className='flex flex-row justify-start items-start my-4 w-full'>
                <div>

                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Amount
                    </InputLabel>
                    <NumberInput
                        marginTop={'8px'}
                        value={recipeVitaminE}
                        onChange={(value) => setRecipeVitaminE(value)}
                    />
                </div>
                <div className='ml-4'>
                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Unit
                    </InputLabel>
                    <Select
                        sx={{ width: '100px', marginTop: '8px' }}
                        value={recipeVitaminEUnit}
                        label="Vitamin E Unit"
                        onChange={(e: any) => setRecipeVitaminEUnit(e.target.value)}>
                        {
                            vitaminUnits.map((unit: any) => {
                                return (
                                    <MenuItem value={unit.title}>{unit.value}</MenuItem>
                                )
                            })
                        }
                    </Select>
                </div>
            </div>
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Vitamin K
            </InputLabel>
            <div className='flex flex-row justify-start items-start my-4 w-full'>
                <div>

                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Amount
                    </InputLabel>
                    <NumberInput
                        marginTop={'8px'}
                        value={recipeVitaminK}
                        onChange={(value) => setRecipeVitaminK(value)}
                    />
                </div>
                <div className='ml-4'>
                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Unit
                    </InputLabel>
                    <Select
                        sx={{ width: '100px', marginTop: '8px' }}
                        value={recipeVitaminKUnit}
                        label="Vitamin K Unit"
                        onChange={(e: any) => setRecipeVitaminKUnit(e.target.value)}>
                        {
                            vitaminUnits.map((unit: any) => {
                                return (
                                    <MenuItem value={unit.title}>{unit.value}</MenuItem>
                                )
                            })
                        }
                    </Select>
                </div>
            </div>
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Cholesterol
            </InputLabel>
            <div className='flex flex-row justify-start items-start my-4 w-full'>
                <div>

                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Amount
                    </InputLabel>
                    <NumberInput
                        marginTop={'8px'}
                        value={recipeCholesterol}
                        onChange={(value) => setRecipeCholesterol(value)}
                    />
                </div>
                <div className='ml-4'>
                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Unit
                    </InputLabel>
                    <Select
                        sx={{ width: '100px', marginTop: '8px' }}
                        value={recipeCholesterolUnit}
                        label="Cholesterol"
                        onChange={(e: any) => setRecipeCholesterolUnit(e.target.value)}>
                        {
                            vitaminUnits.map((unit: any) => {
                                return (
                                    <MenuItem value={unit.title}>{unit.value}</MenuItem>
                                )
                            })
                        }
                    </Select>
                </div>
            </div>
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Choline
            </InputLabel>
            <div className='flex flex-row justify-start items-start my-4 w-full'>
                <div>

                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Amount
                    </InputLabel>
                    <NumberInput
                        marginTop={'8px'}
                        value={recipeCholine}
                        onChange={(value) => setRecipeCholine(value)}
                    />
                </div>
                <div className='ml-4'>
                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Unit
                    </InputLabel>
                    <Select
                        sx={{ width: '100px', marginTop: '8px' }}
                        value={recipeCholineUnit}
                        label="Choline"
                        onChange={(e: any) => setRecipeCholineUnit(e.target.value)}>
                        {
                            vitaminUnits.map((unit: any) => {
                                return (
                                    <MenuItem value={unit.title}>{unit.value}</MenuItem>
                                )
                            })
                        }
                    </Select>
                </div>
            </div>
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Fiber
            </InputLabel>
            <div className='flex flex-row justify-start items-start my-4 w-full'>
                <div>

                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Amount
                    </InputLabel>
                    <NumberInput
                        marginTop={'8px'}
                        value={recipeFiber}
                        onChange={(value) => setRecipeFiber(value)}
                    />
                </div>
                <div className='ml-4'>
                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Unit
                    </InputLabel>
                    <Select
                        sx={{ width: '100px', marginTop: '8px' }}
                        value={recipeFiberUnit}
                        label="Fiber"
                        onChange={(e: any) => setRecipeFiberUnit(e.target.value)}>
                        {
                            vitaminUnits.map((unit: any) => {
                                return (
                                    <MenuItem value={unit.title}>{unit.value}</MenuItem>
                                )
                            })
                        }
                    </Select>
                </div>
            </div>
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Folate
            </InputLabel>
            <div className='flex flex-row justify-start items-start my-4 w-full'>
                <div>

                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Amount
                    </InputLabel>
                    <NumberInput
                        marginTop={'8px'}
                        value={recipeFolicAcid}
                        onChange={(value) => setRecipeFolicAcid(value)}
                    />
                </div>
                <div className='ml-4'>
                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Unit
                    </InputLabel>
                    <Select
                        sx={{ width: '100px', marginTop: '8px' }}
                        value={recipeFolicAcidUnit}
                        label="Folate"
                        onChange={(e: any) => setRecipeFolicAcidUnit(e.target.value)}>
                        {
                            vitaminUnits.map((unit: any) => {
                                return (
                                    <MenuItem value={unit.title}>{unit.value}</MenuItem>
                                )
                            })
                        }
                    </Select>
                </div>
            </div>
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Iodine
            </InputLabel>
            <div className='flex flex-row justify-start items-start my-4 w-full'>
                <div>

                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Amount
                    </InputLabel>
                    <NumberInput
                        marginTop={'8px'}
                        value={recipeIodine}
                        onChange={(value) => setRecipeIodine(value)}
                    />
                </div>
                <div className='ml-4'>
                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Unit
                    </InputLabel>
                    <Select
                        sx={{ width: '100px', marginTop: '8px' }}
                        value={recipeIodineUnit}
                        label="Iodine"
                        onChange={(e: any) => setRecipeIodineUnit(e.target.value)}>
                        {
                            vitaminUnits.map((unit: any) => {
                                return (
                                    <MenuItem value={unit.title}>{unit.value}</MenuItem>
                                )
                            })
                        }
                    </Select>
                </div>
            </div>
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Iron
            </InputLabel>
            <div className='flex flex-row justify-start items-start my-4 w-full'>
                <div>

                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Amount
                    </InputLabel>
                    <NumberInput
                        marginTop={'8px'}
                        value={recipeIron}
                        onChange={(value) => setRecipeIron(value)}
                    />
                </div>
                <div className='ml-4'>
                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Unit
                    </InputLabel>
                    <Select
                        sx={{ width: '100px', marginTop: '8px' }}
                        value={recipeIronUnit}
                        label="Iron"
                        onChange={(e: any) => setRecipeIronUnit(e.target.value)}>
                        {
                            vitaminUnits.map((unit: any) => {
                                return (
                                    <MenuItem value={unit.title}>{unit.value}</MenuItem>
                                )
                            })
                        }
                    </Select>
                </div>
            </div>
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Magnesium
            </InputLabel>
            <div className='flex flex-row justify-start items-start my-4 w-full'>
                <div>

                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Amount
                    </InputLabel>
                    <NumberInput
                        marginTop={'8px'}
                        value={recipeMagnesium}
                        onChange={(value) => setRecipeMagnesium(value)}
                    />
                </div>
                <div className='ml-4'>
                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Unit
                    </InputLabel>
                    <Select
                        sx={{ width: '100px', marginTop: '8px' }}
                        value={recipeMagnesiumUnit}
                        label="Magnesium"
                        onChange={(e: any) => setRecipeMagnesiumUnit(e.target.value)}>
                        {
                            vitaminUnits.map((unit: any) => {
                                return (
                                    <MenuItem value={unit.title}>{unit.value}</MenuItem>
                                )
                            })
                        }
                    </Select>
                </div>
            </div>
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Potassium
            </InputLabel>
            <div className='flex flex-row justify-start items-start my-4 w-full'>
                <div>

                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Amount
                    </InputLabel>
                    <NumberInput
                        marginTop={'8px'}
                        value={recipePotassium}
                        onChange={(value) => setRecipePotassium(value)}
                    />
                </div>
                <div className='ml-4'>
                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Unit
                    </InputLabel>
                    <Select
                        sx={{ width: '100px', marginTop: '8px' }}
                        value={recipePotassiumUnit}
                        label="Potassium"
                        onChange={(e: any) => setRecipePotassiumUnit(e.target.value)}>
                        {
                            vitaminUnits.map((unit: any) => {
                                return (
                                    <MenuItem value={unit.title}>{unit.value}</MenuItem>
                                )
                            })
                        }
                    </Select>
                </div>
            </div>
            <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Saturated Fat
            </InputLabel>
            <div className='flex flex-row justify-start items-start my-4 w-full'>
                <div>

                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Amount
                    </InputLabel>
                    <NumberInput
                        marginTop={'8px'}
                        value={recipeSaturatedFat}
                        onChange={(value) => setRecipeSaturatedFat(value)}
                    />
                </div>
                <div className='ml-4'>
                    <InputLabel
                        style={{
                            alignSelf: 'flex-start',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: 'gray',
                            marginBottom: '8px',
                            marginTop: '8px'
                        }}>
                        Unit
                    </InputLabel>
                    <Select
                        sx={{ width: '100px', marginTop: '8px' }}
                        value={recipeSaturatedFatUnit}
                        label="Saturated Fat"
                        onChange={(e: any) => setRecipeSaturatedFatUnit(e.target.value)}>
                        {
                            vitaminUnits.map((unit: any) => {
                                return (
                                    <MenuItem value={unit.title}>{unit.value}</MenuItem>
                                )
                            })
                        }
                    </Select>
                </div>
            </div>
            {/* <InputLabel
                style={{
                    alignSelf: 'flex-start',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    marginTop: '16px'
                }}>
                Recipe Vitamins
            </InputLabel>
            <TextField
                label='Recipe Vitamins'
                variant='filled'
                style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                type="number"
                placeholder='Recipe Vitamins'
                value={recipeVitamins}
                onChange={(e) => setRecipeVitamins(parseInt(e.target.value))}
            /> */}
            <div className='w-full flex flex-row justify-start items-center my-8'>
                <InputLabel
                    style={{
                        alignSelf: 'flex-start',
                        fontSize: '16px',
                        fontWeight: '600',
                        color: 'black',
                        marginTop: '8px'
                    }}>
                    For Premium Users:
                </InputLabel>
                <Switch checked={isPremium} onChange={(e) => setIsPremium(e.target.checked)} />

            </div>
            {
                recipesLoading === true
                    ? <Button
                        onClick={() => { }}
                        disabled
                        style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                        variant='contained'
                        color='primary'>
                        Adding...
                    </Button>
                    : <Button
                        onClick={addNewRecipe}
                        disabled={
                            recipeName === '' ||
                            recipeType === '' ||
                            recipeTrimester === '' ||
                            recipePreparationTime === 0 ||
                            recipeServes === 0 ||
                            recipeMethod === '' ||
                            recipeIngredients.length === 0 ||
                            recipeImage === ''
                        }
                        style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                        variant='contained'
                        color='primary'>
                        Add Recipe
                    </Button>
            }

        </div >
    )
}
